import {myFetchBaseQuery, MyFetchBaseQueryArgs} from "./myFetchBaseQuery";
import {RootState} from "@app/store";
import {CoreState} from "@commons/core.state";

export type PlatformType = 'ios' | 'android' | 'windows' | 'macos' | 'web'

export interface FetchConfig {
    //useDefaultPropertyNamingStrategy: boolean,
    isMobile: boolean,
    platformType: PlatformType | null,
}

export const fetchConfig: FetchConfig = {
    //useDefaultPropertyNamingStrategy: true,
    isMobile: false,
    platformType: 'web',
}

export function fetchBaseFPNetQuery(options: MyFetchBaseQueryArgs) {
    return myFetchBaseQuery({
        ...options, prepareParams: (params, {getState}) => {
            const auth = (getState() as RootState).auth as CoreState;
            const token: string | undefined = (auth && auth.loginResult && auth.loginResult.token) ? auth.loginResult.token.token as string : undefined;
            // If we have a token set in state, let's assume that we should be passing it.
            if (token) {
                if (!params) {
                    params = {
                        auth_token: token,
                        //useDefaultPropertyNamingStrategy: fetchConfig.useDefaultPropertyNamingStrategy,
                        isMobile: fetchConfig.isMobile,
                        device: fetchConfig.platformType,
                    }
                } else {
                    params.set('auth_token', token);
                    //params.set('useDefaultPropertyNamingStrategy', fetchConfig.useDefaultPropertyNamingStrategy);
                    params.set('isMobile', fetchConfig.isMobile);
                    params.set('device', fetchConfig.platformType);
                }
            }
            return params;
        },
    });
}